import {
  Directive,
  ElementRef,
  HostListener,
  Inject,
  Input,
  NgZone,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { InputMaskConfig, InputMaskDirective } from '@ngneat/input-mask';

import { INPUT_MASK_CONFIG2 } from './input-mask-custom-config';

@Directive({
  selector: '[inputMask]',
  standalone: false
})
export class InputMaskCustomDirective extends InputMaskDirective {
  constructor(
    @Inject(PLATFORM_ID) private platformId2: string,
    private elementRef2: ElementRef<HTMLInputElement | any>,
    private renderer2: Renderer2,
    public ngControl2: NgControl | null,
    @Inject(INPUT_MASK_CONFIG2) config: InputMaskConfig,
    private ngZone2: NgZone
  ) {
    super(platformId2, elementRef2, renderer2, ngControl2, config, ngZone2);
  }

  @HostListener('cut') onCut(): void {
    this.ngControl?.control?.updateValueAndValidity();
  }

  @HostListener('blur', ['$event']) onBlur(event: FocusEvent): void {
    const value = (event.target as HTMLInputElement).value;
    if (
      this.inputMaskPlugin?.getemptymask() === value ||
      (!this.ngControl?.control?.value && !value)
    ) {
      this.ngControl?.control?.setValue(null);
      this.ngControl?.control?.updateValueAndValidity();
    }
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent): void {
    const value = (event.target as HTMLInputElement).value;
    if (
      this.inputMaskPlugin?.getemptymask() === value ||
      (!this.ngControl?.control?.value && !value)
    ) {
      this.ngControl?.control?.setValue(null);
      this.ngControl?.control?.updateValueAndValidity();
    }
  }

  @HostListener('change', ['$event']) onChanges(event: Event): void {
    this.ngControl?.control?.patchValue(
      (event.target as HTMLInputElement).value
    );
    this.ngControl?.control?.updateValueAndValidity();
  }
}
